import { forwardRef, type ImgHTMLAttributes } from 'react';
import { cn } from '@/shared/lib/cn';
import markUrl from '@/shared/assets/brand/workerize-primary-mark.svg';

export interface WorkerizeMarkProps
  extends Omit<ImgHTMLAttributes<HTMLImageElement>, 'src' | 'alt'> {
  size?: number;
  title?: string;
}

/**
 * The canonical Workerize mark (the lime "W" check). One file per logical asset
 * (DEC-040 / DEC-047). The artwork is taller than it is wide (5:6), so `size`
 * drives the HEIGHT and the width follows the intrinsic ratio — never force it
 * square or the mark distorts. Theme-stable (lime); the on-light/on-dark
 * variants live in {@link WorkerizeMarkThemed}.
 */
export const WorkerizeMark = forwardRef<HTMLImageElement, WorkerizeMarkProps>(
  function WorkerizeMark(
    { size = 48, title = 'Workerize', className, ...rest },
    ref,
  ) {
    return (
      <img
        ref={ref}
        src={markUrl}
        alt={title}
        height={size}
        className={cn('inline-block w-auto', className)}
        style={{ height: `${size}px` }}
        {...rest}
      />
    );
  },
);
